import { render, staticRenderFns } from "./FBScript.vue?vue&type=template&id=4a7851b1&"
import script from "./FBScript.vue?vue&type=script&lang=js&"
export * from "./FBScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports